import React from 'react';
import SqftIcon from 'components/icon/sqft-icon';
import BathIcon from 'components/icon/bath-icon';
import BedIcon from 'components/icon/bed-icon';
import SqftText from 'components/sqft-text';
import styles from './style.module.scss';
import { listingCardIds } from 'constants/test-constants';
import { useTranslation } from 'next-i18next';
import { LOCALE_COMMON_PATHS, Namespaces } from 'types/locales';
import { localizeSqftLabel } from 'ui/sqft';

//#region Types
export type ListingBedBathSqftLabelsProps = {
  bedrooms: number;
  bathrooms: number;
  sqftLabel: string;
};
//#endregion

export default function ListingBedBathSqftLabels({ bedrooms, bathrooms, sqftLabel }: ListingBedBathSqftLabelsProps) {
  const { t } = useTranslation(Namespaces.COMMON);
  
  return (
    <div className={styles.row}>
      <div>
        <p className={styles['listing-detail']} data-testid={listingCardIds.listingBeds}>
          <BedIcon className={styles.icon} />
          {t(LOCALE_COMMON_PATHS.LISTING_CARD_NUMBER_OF_BEDROOMS, {
            count: bedrooms,
            difference: '',
            defaultValue: `${bedrooms} Bd`,
          })}
        </p>
        <p className={styles['listing-detail']} data-testid={listingCardIds.listingBathrooms}>
          <BathIcon className={styles.icon} />
          {t(LOCALE_COMMON_PATHS.LISTING_CARD_NUMBER_OF_BATHROOMS, {
            count: bathrooms,
            difference: '',
            defaultValue: `${bathrooms} Ba`,
          })}
        </p>
        <p className={styles['listing-detail']} data-testid={listingCardIds.listingSqft}>
          <SqftIcon className={styles.icon} />
          <SqftText squareFootageLabel={sqftLabel} render={formattedSqft => <>{localizeSqftLabel(formattedSqft, t)}</>} />
        </p>
      </div>
    </div>
  );
}
